import jsPDF from 'jspdf';
import eg_logo from '../pages/EGQuotation/Quotation_images/eg_logo.png';
import wg_logo from '../pages/WGQuotation/Quotation_images/wg_logo.png'
import badge_backdrop from '../pages/EGQuotation/Quotation_images/badge-backdrop.png';
import WMG_badge from '../pages/EGQuotation/Quotation_images/WMG-badge.png';
import WS_badge from '../pages/EGQuotation/Quotation_images/WS-badge.png';
import WSP from '../pages/EGQuotation/Quotation_images/badge-runnerup(2024).png';
import WS_25 from '../pages/EGQuotation/Quotation_images/WS_2025_badge.png'
import WS_26 from '../pages/EGQuotation/Quotation_images/WS_2026_badge.png'
import whyEG from '../pages/EGQuotation/Quotation_images/whyEventgraphia.jpg';
import whyWG from '../pages/WGQuotation/Quotation_images/whyWG.jpg';
import delDiv from '../pages/EGQuotation/Quotation_images/del-div.jpg';
import delDivWG from '../pages/WGQuotation/Quotation_images/del-div-wg.jpg';
import prePost from '../pages/EGQuotation/Quotation_images/pre_post.jpg';
import prePostWG from '../pages/WGQuotation/Quotation_images/pre-post-wg.jpg';
import Akshay from '../pages/WGQuotation/Quotation_images/Akshay.JPG';
import artecallya from '../fonts/artecallya/Artecallya-Script.ttf'
import montserratMedium from '../fonts/montserrat/Montserrat-Medium.ttf'
import montserrat from '../fonts/montserrat/Montserrat-Regular.ttf'
import { Platform, termsConditions, hasTokenInstallment, withQuotationYear } from "./util"

class PDFGenerator {
    constructor(data, isWedding, progressCallback, loadingCallback) {
        this.data = data;
        this.pdf = new jsPDF({
            orientation: 'landscape',
            unit: 'in',
            format: [15, 7.5],
            compress: true,
        });
        this.bgColor = Platform.isEG ? [233, 196, 187] : [212, 191, 172];
        this.textColor = Platform.isEG ? [159, 120, 102] : [84, 77, 68];
        this.company = Platform.isEG ? 'EventGraphia' : 'WedGraphia';
        this.isWedding = isWedding;
        this.progressCallback = progressCallback || (() => {});
        this.loadingCallback = loadingCallback || (() => {});
    }

    loadImage(src) {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = src;
            img.onload = () => resolve(img);
        });
    }

    getImageDimensions(src) {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                resolve({
                    width: img.naturalWidth,
                    height: img.naturalHeight,
                });
            };
            img.src = src;
        });
    }

    async coverPage() {
        const { pdf } = this;
    
        pdf.setFillColor(...this.bgColor);
        pdf.rect(0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height, 'F');
    
        const logoSrc = Platform.isEG ? eg_logo : wg_logo;
        
        const img = await this.loadImage(logoSrc);
        const imageDimensions = await this.getImageDimensions(logoSrc);
    
        const originalWidth = imageDimensions.width;
        const originalHeight = imageDimensions.height;
    
        const aspectRatio = originalWidth / originalHeight;
    
        const maxWidth = Platform.isEG ? pdf.internal.pageSize.width * 0.25 : pdf.internal.pageSize.width * 0.5;
        const maxHeight = Platform.isEG ? pdf.internal.pageSize.height * 0.25 : pdf.internal.pageSize.height * 0.5;
    
        let imgWidth, imgHeight;
    
        if (maxWidth / aspectRatio <= maxHeight) {
            imgWidth = maxWidth;
            imgHeight = maxWidth / aspectRatio;
        } else {
            imgHeight = maxHeight;
            imgWidth = maxHeight * aspectRatio;
        }
    
        const imgX = (pdf.internal.pageSize.width - imgWidth) / 2;
        const imgY = (pdf.internal.pageSize.height - imgHeight) / 2-1;
    
        const spaceBetween = 0.80;
    
        pdf.addImage(img, 'JPEG', imgX, imgY, imgWidth, imgHeight);
    
        const text = 'Making Memories';
        pdf.setTextColor(...this.textColor);
        pdf.setFontSize(60);
        pdf.addFont(artecallya, 'artecallya', 'normal');
        pdf.setFont('artecallya');
        
        const textWidth = pdf.getTextWidth(text);
        const textX = (pdf.internal.pageSize.width - textWidth) / 2;
        const textY = imgY + imgHeight + spaceBetween;
    
        if (Platform.isEG) {
            pdf.text(text, textX, textY);
        }
    }

    async awardPage() {
        const { pdf } = this;
        pdf.addPage();

        // Newest award first, matching the order of the awards section on
        // the quotation page.
        const badges = [WS_26, WS_25, WSP, WMG_badge, WS_badge];

        // Each badge gets an equal slice of the page width; the badge is
        // drawn narrower than its slice so the row keeps a gutter between them.
        const slotWidth = pdf.internal.pageSize.width / badges.length;
        const boxSize = 2.6;
        const rowCenterY = pdf.internal.pageSize.height / 2;

        const bgImg = await this.loadImage(badge_backdrop);
        const badgeImgs = await Promise.all(badges.map((badge) => this.loadImage(badge)));

        pdf.addImage(bgImg, 'JPEG', 0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height);

        badgeImgs.forEach((badgeImg, index) => {
            // The badges are not all the same shape, so fit each one inside
            // the box instead of forcing it square — drawing the wider 2026
            // badge at a square size would stretch it vertically.
            const scale = Math.min(boxSize / badgeImg.naturalWidth, boxSize / badgeImg.naturalHeight);
            const imgWidth = badgeImg.naturalWidth * scale;
            const imgHeight = badgeImg.naturalHeight * scale;
            const imgX = index * slotWidth + (slotWidth - imgWidth) / 2;
            const imgY = rowCenterY - imgHeight / 2;
            pdf.addImage(badgeImg, 'JPEG', imgX, imgY, imgWidth, imgHeight);
        });
    }

    async nonWeddingWhy() {
        const { pdf } = this;

        pdf.addPage();

        const bgImg = await this.loadImage(Akshay);
        pdf.addImage(bgImg, 'PNG', 0, 0, pdf.internal.pageSize.width/3, pdf.internal.pageSize.height);

        pdf.addFont(montserratMedium, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal');
        pdf.setFontSize(42);
        pdf.setTextColor(...this.textColor);
        const title =  Platform.isEG ? 'WHY EVENTGRAPHIA?' : 'WHY WEDGRAPHIA?';
        pdf.text(title, pdf.internal.pageSize.width/3 + 0.5, 1.2);

        pdf.setFontSize(20);
        pdf.addFont(montserratMedium, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal');
        pdf.setTextColor(...this.textColor);

        const description = [
            `${this.company} is a Premium Event Photography Service space.`,
            "We provide seamless end-to-end solutions right from booking",
            "inquiry to the delivery of photos, videos and albums, all digitally",
            "using our web app."
        ];
        
        let currentY = 2;
        description.forEach(line => {
            pdf.text(line, pdf.internal.pageSize.width/3 + 0.5, currentY);
            currentY += 0.4;
        });

        const bulletPoints = [
            "• India's Largest Event Photography Company",
            "• Serving 175+ Cities",
            "• 210+ Professionals",
            "• Covered 500+ Weddings",
            "• State of the art Equipments",
            "• Customers - BMW, TAJ, Uber, Dominos, Harley Davidson,",
            "  Hello English, Oyo Rooms"
        ];
        
        currentY += 0.3;
        bulletPoints.forEach(point => {
            pdf.text(point, pdf.internal.pageSize.width/3 + 0.5, currentY);
            currentY += 0.5;
        });

    }

    async schedulePage(value) {
    const { pdf } = this;
    const pageHeight = pdf.internal.pageSize.height; // 7.5
    const bottomMargin = 0.8;
    const titleY = 1.2;
    const startEventsY = 2.3;

    const addNewPage = () => {
        pdf.addPage();
        pdf.setFillColor(251, 247, 244);
        pdf.rect(0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height, 'F');
        renderTitle(titleY);
    };

    const renderTitle = (y) => {
        pdf.addFont(montserratMedium, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal');
        pdf.setFontSize(42);
        pdf.setTextColor(...this.textColor);
        const pageWidth = pdf.internal.pageSize.width;
        const title = 'SCHEDULE';
        const titleWidth = pdf.getTextWidth(title);
        pdf.text(title, (pageWidth - titleWidth) / 2, y);
    };

    const calculatePositions = (numDates) => {
        const boxWidth = 2.5;
        const pageWidth = pdf.internal.pageSize.width;
        const totalRowWidth = numDates * boxWidth;
        const spacing = (pageWidth - totalRowWidth) / (numDates + 1);
        const positions = [];
        for (let i = 0; i < numDates; i++) {
            positions.push(spacing * (i + 1) + i * boxWidth);
        }
        return positions;
    };

    let dateIndex = 0;
    const maxDatesPerRow = 4; 
    // Four dates a row leave 3.5in from one column to the next.
    const maxDateTitleWidth = 3.3;

    while (dateIndex < value.length) {
        addNewPage();
        
        // Grab the next set of dates (up to 4) to show side-by-side
        const datesOnThisPage = value.slice(dateIndex, dateIndex + maxDatesPerRow);
        const positions = calculatePositions(datesOnThisPage.length);
        
        // Track the Y position for each column independently
        let columnYPositions = datesOnThisPage.map(() => startEventsY);

        // We need to loop through the events of these dates
        // Find the date with the most events to know when we are "done" with this page
        const maxEvents = Math.max(...datesOnThisPage.map(d => d.events_name.length));

        for (let eventIdx = 0; eventIdx < maxEvents; eventIdx++) {
            
            // Check if ANY column is about to hit the bottom of the page
            // If so, we must break and start a new page for the remaining events
            if (Math.max(...columnYPositions) > (pageHeight - bottomMargin)) {
                pdf.setFontSize(14);
                pdf.text("... continued on next page", pdf.internal.pageSize.width - 3, pageHeight - 0.4);
                
                addNewPage();
                // Reset Y positions for the new page
                columnYPositions = columnYPositions.map(() => startEventsY);
            }

            // Draw one event for each date in its respective column
            datesOnThisPage.forEach((dateItem, colIdx) => {
                const x = positions[colIdx];
                let curY = columnYPositions[colIdx];

                // ONLY DRAW IF THIS DATE HAS EVENTS LEFT
                const eventName = dateItem.events_name[eventIdx];
                
                if (eventName) {
                    // Draw the Date Title ONLY on the first event of the page
                    if (eventIdx === 0 || curY === startEventsY) {
                        pdf.setFontSize(24);
                        pdf.addFont(montserratMedium, 'montserrat', 'medium');
                        pdf.setFont('montserrat', 'medium');
                        // With the year, a long date like "25th September, 2026"
                        // runs into the next column at 24pt, so shrink just that one.
                        const dateTitle = withQuotationYear(dateItem.date_data.date_str, dateItem.date_data);
                        const dateTitleWidth = pdf.getTextWidth(dateTitle);
                        if (dateTitleWidth > maxDateTitleWidth) {
                            pdf.setFontSize(24 * maxDateTitleWidth / dateTitleWidth);
                        }
                        pdf.text(dateTitle, x, curY);
                        curY += 0.7;
                    }

                    pdf.setFontSize(17);
                    pdf.setFont('montserrat', 'normal');
                    const wrappedText = pdf.splitTextToSize(`• ${eventName}`, 2.3);
                    pdf.text(wrappedText, x, curY);
                    
                    columnYPositions[colIdx] = curY + (wrappedText.length * 0.35) + 0.15;
                }
            });
        }

        dateIndex += maxDatesPerRow;
    }
} 
  async eventsPage(values) {
        const { pdf } = this;
        const pageHeight = pdf.internal.pageSize.height; 
        const pageWidth = pdf.internal.pageSize.width;   
        const bottomMargin = 0.5; 
        const titleY = 0.8;

        const renderFullHeader = (eventItem) => {
            pdf.addPage();
            pdf.setFillColor(...this.bgColor);
            pdf.rect(0, 0, pageWidth, pageHeight, 'F');

            pdf.setFontSize(32);
            pdf.setTextColor(...this.textColor);
            pdf.addFont(montserratMedium, 'montserrat', 'bold');
            pdf.setFont('montserrat', 'bold');
            pdf.text(withQuotationYear(eventItem.date_data.date_str, eventItem.date_data), 1.0, titleY);

            pdf.setFontSize(23); 
            pdf.addFont(montserratMedium, 'montserrat', 'bold');
            pdf.setFont('montserrat', 'bold');
            
            // Fix: Safe array joining
            const summary = (eventItem.events_name || []).join(", ");
            const wrappedSummary = pdf.splitTextToSize(`(${summary})`, pageWidth - 2.0);
            pdf.text(wrappedSummary, 1.0, titleY + 0.4);

            return titleY + 0.4 + (wrappedSummary.length * 0.28) + 0.6;
        };

        for (const eventItem of values) {
            let currentY = renderFullHeader(eventItem);
            
            const col1X = 1.0;
            const col2X = (pageWidth / 2) + 0.2;
            const colWidth = (pageWidth / 2) - 1.2;

            // Usable height on a freshly-headered page. An event taller than this
            // cannot fit in a single column and must be paginated on its own.
            const freshPageCapacity =
                (pageHeight - bottomMargin) - (titleY + 0.4 + 0.28 + 0.6);

            let eventIndex = 0;
            const eventDataLength = (eventItem.event_data || []).length;

            while (eventIndex < eventDataLength) {
                const ev1 = eventItem.event_data[eventIndex];
                const name1 = (eventItem.events_name || [])[eventIndex] || 'Event';
                const h1 = this.calculateEventHeight(ev1, name1, colWidth);

                // An event taller than a whole page can't fit in one column, so draw
                // it solo (never paired) and let its product list + time block flow
                // across continuation pages via the pager.
                if (h1 > freshPageCapacity) {
                    if (currentY + h1 > pageHeight - bottomMargin && currentY > 2.5) {
                        currentY = renderFullHeader(eventItem);
                    }
                    const pager = { headerFn: renderFullHeader, eventItem, bottomMargin };
                    const endY = this.drawSingleEvent(ev1, name1, col1X, currentY, colWidth, pager);
                    currentY = endY + 0.5;
                    eventIndex += 1;
                    continue;
                }

                // Fix: Removed the bugged (h1 * 0.5). We check if FULL height fits.
                if (currentY + h1 > pageHeight - bottomMargin && currentY > 2.5) {
                    currentY = renderFullHeader(eventItem);
                }

                const rowStartY = currentY;
                const endY1 = this.drawSingleEvent(ev1, name1, col1X, rowStartY, colWidth);
                let endY2 = rowStartY;

                if (eventIndex + 1 < eventDataLength) {
                    const ev2 = eventItem.event_data[eventIndex + 1];
                    const name2 = (eventItem.events_name || [])[eventIndex + 1] || 'Event';
                    const h2 = this.calculateEventHeight(ev2, name2, colWidth);

                    if (rowStartY + h2 < pageHeight - bottomMargin) {
                        endY2 = this.drawSingleEvent(ev2, name2, col2X, rowStartY, colWidth);
                        eventIndex += 2; 
                    } else {
                        eventIndex += 1; 
                    }
                } else {
                    eventIndex += 1;
                }

                currentY = Math.max(endY1, endY2) + 0.5;
            }
            this.renderDayNotice(eventItem, currentY, renderFullHeader);
        }
    }

    // --- SUPPORTING HELPERS (Unified & Bug-free) --- //

    buildTimeAndNotesLines(event) {
        const timeAndNotes = [];
        if (event.start_time) timeAndNotes.push(`* Start Time: ${event.start_time}`);
        if (event.end_time) timeAndNotes.push(`* End Time: ${event.end_time}`);
        (event.notes || []).filter(Boolean).forEach(note => timeAndNotes.push(`* ${note}`));
        return timeAndNotes;
    }

    measureTimeAndNotesHeight(event, width) {
        const { pdf } = this;
        const timeAndNotes = this.buildTimeAndNotesLines(event);
        if (timeAndNotes.length === 0) return 0;

        pdf.setFontSize(14);
        pdf.setFont('montserrat', 'normal');

        let h = 0;
        timeAndNotes.forEach(line => {
            const nLines = pdf.splitTextToSize(line, width);
            h += (nLines.length * 0.28);
        });
        return h;
    }

    drawTimeAndNotes(event, x, curY, width, pager = null) {
        const { pdf } = this;
        const timeAndNotes = this.buildTimeAndNotesLines(event);
        if (timeAndNotes.length === 0) return curY;

        const pageHeight = pdf.internal.pageSize.height;

        pdf.setFontSize(14);
        pdf.setFont('montserrat', 'normal');

        timeAndNotes.forEach(line => {
            const nLines = pdf.splitTextToSize(line, width);
            const lineH = nLines.length * 0.28;
            // With a pager, a long notes list flows across continuation pages
            // instead of overflowing off the bottom.
            if (pager && curY + lineH > pageHeight - pager.bottomMargin) {
                curY = pager.headerFn(pager.eventItem);
                pdf.setFontSize(14);
                pdf.setTextColor(...this.textColor);
                pdf.setFont('montserrat', 'normal');
            }
            pdf.text(nLines, x, curY);
            curY += lineH;
        });
        return curY;
    }

    calculateEventHeight(event, name, width) {
        const { pdf } = this;
        let h = 0.4; // Initial height for Event Name

        if (event.venue_str) {
            pdf.setFontSize(16);
            pdf.setFont('montserrat', 'normal'); // Fix: Enforce active font
            const vLines = pdf.splitTextToSize(event.venue_str, width);
            h += (vLines.length * 0.25) + 0.3;
        }

        pdf.setFontSize(18);
        pdf.setFont('montserrat', 'normal'); // Fix: Enforce active font
        
        // Fix: Safe Fallback for empty/missing products
        (event.event_products_cnt || []).forEach(item => {
            const lines = pdf.splitTextToSize(`• ${item}`, width);
            h += (lines.length * 0.35); 
        });

        h += this.measureTimeAndNotesHeight(event, width);
        return h + 0.4; 
    }

    drawSingleEvent(event, name, x, y, width, pager = null) {
        const { pdf } = this;
        let curY = y;

        // When a pager is supplied, an over-tall event can flow onto continuation
        // pages instead of overflowing off the bottom (which used to hide the
        // Start/End time block). Without a pager, behavior is unchanged.
        const pageHeight = pdf.internal.pageSize.height;
        const ensureSpace = (needed) => {
            if (!pager) return;
            if (curY + needed > pageHeight - pager.bottomMargin) {
                curY = pager.headerFn(pager.eventItem);
            }
        };

        pdf.setFontSize(24);
        pdf.setTextColor(...this.textColor);
        pdf.addFont(montserratMedium, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal'); // Fix: Critical missing font set
        pdf.text(name, x, curY);
        curY += 0.4;

        if (event.venue_str) {
            pdf.setFontSize(16);
            pdf.addFont(montserrat, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal'); // Fix
            const vLines = pdf.splitTextToSize(event.venue_str, width);
            pdf.text(vLines, x, curY);
            curY += (vLines.length * 0.25) + 0.2;
        }

        pdf.setFontSize(18);
        pdf.setFont('montserrat', 'normal'); // Fix
        (event.event_products_cnt || []).forEach(item => {
            const lines = pdf.splitTextToSize(`• ${item}`, width);
            const lineH = lines.length * 0.35;
            ensureSpace(lineH);
            // Re-assert styling in case ensureSpace started a new page (headerFn
            // leaves the pdf in a 23pt bold state).
            pdf.setFontSize(18);
            pdf.setTextColor(...this.textColor);
            pdf.setFont('montserrat', 'normal');
            pdf.text(lines, x, curY);
            curY += lineH;
        });

        // The time + notes block paginates line-by-line (via the pager) so a long
        // notes list flows across pages instead of overflowing off the bottom.
        curY = this.drawTimeAndNotes(event, x, curY, width, pager);
        return curY;
    }
renderDayNotice(eventItem, y, headerFn) {
        const { pdf } = this;
        const pageHeight = pdf.internal.pageSize.height;
        let curY = y;

        if (!eventItem.start_at && !eventItem.end_at && (!eventItem.notes || eventItem.notes.length === 0)) return;

        // Ensure we have enough room to start
        if (curY > pageHeight - 1.0) {
            curY = headerFn(eventItem);
        }

        // 1. Draw Heading
        pdf.setFontSize(18);
        pdf.setTextColor(...this.textColor);
        pdf.setFillColor(...this.bgColor);
        pdf.setFont('montserrat', 'bold');
        pdf.text(`Coverage Details for ${withQuotationYear(eventItem.date_data.date_str, eventItem.date_data)}:`, 1.0, curY);
        curY += 0.30; // Tightened gap under the heading
        
        // 2. Draw Start/End Times
        pdf.setFontSize(13); // Decreased font size from 14 to 13
        pdf.setFont('montserrat', 'normal');

        if (eventItem.start_at) { 
            pdf.text(`• Start: ${eventItem.start_at}`, 1.0, curY); 
            curY += 0.20; // Decreased line spacing from 0.25 to 0.20
        }
        if (eventItem.end_at) { 
            pdf.text(`• End: ${eventItem.end_at}`, 1.0, curY); 
            curY += 0.20; // Decreased line spacing
        }
        
        // 3. Draw Notes Line-by-Line
        if (eventItem.notes && eventItem.notes.length > 0) {
            curY += 0.05; // Tiny gap before notes start
            
            eventItem.notes.forEach(note => {
                pdf.setFontSize(14); // Decreased notes font size to 12
                const wrapped = pdf.splitTextToSize(`* ${note}`, pdf.internal.pageSize.width - 2.0);
                
                wrapped.forEach(line => {
                    if (curY > pageHeight - 0.5) {
                        curY = headerFn(eventItem);
                        
                        // Reset styling after headerFn changes it to 23pt
                        pdf.setFontSize(14);
                        pdf.setTextColor(...this.textColor);
                        pdf.setFont('montserrat', 'normal');
                    }
                    pdf.text(line, 1.0, curY);
                    curY += 0.25; // Decreased line spacing from 0.25 to 0.18 for a tighter look
                });
                
                // Add a very small gap between separate bullet points
                curY += 0.04;
            });
        }
    }  
    // Helper: Measures vertical space an event needs before drawing it
    // calculateEventHeight(event, name, width) {
    //     const { pdf } = this;
    //     let h = 0.4; // Initial height for Event Name

    //     pdf.setFontSize(16);
    //     const vLines = pdf.splitTextToSize(event.venue_str || '', width);
    //     h += (vLines.length * 0.25) + 0.3; // Venue

    //     pdf.setFontSize(18);
    //     event.event_products_cnt.forEach(item => {
    //         const lines = pdf.splitTextToSize(`• ${item}`, width);
    //         h += (lines.length * 0.35); // Product points
    //     });

    //     if (event.notes) {
    //         pdf.setFontSize(14);
    //         event.notes.forEach(note => {
    //             const nLines = pdf.splitTextToSize(`* ${note}`, width);
    //             h += (nLines.length * 0.28); // Note lines
    //         });
    //     }
    //     return h + 0.4; // Extra padding
    // }

    // Helper: Draws the event text
    // drawSingleEvent(event, name, x, y, width) {
    //     const { pdf } = this;
    //     let curY = y;

    //     pdf.setFontSize(24);
    //     pdf.setTextColor(...this.textColor);
    //     pdf.addFont(montserratMedium, 'montserrat', 'normal');
    //     pdf.text(name, x, curY);
    //     curY += 0.4;

    //     pdf.setFontSize(16);
    //     pdf.addFont(montserrat, 'montserrat', 'normal');
    //     const vLines = pdf.splitTextToSize(event.venue_str || '', width);
    //     pdf.text(vLines, x, curY);
    //     curY += (vLines.length * 0.25) + 0.2;

    //     pdf.setFontSize(18);
    //     event.event_products_cnt.forEach(item => {
    //         const lines = pdf.splitTextToSize(`• ${item}`, width);
    //         pdf.text(lines, x, curY);
    //         curY += (lines.length * 0.35);
    //     });

    //     if (event.notes) {
    //         pdf.setFontSize(14);
    //         curY += 0.1;
    //         event.notes.forEach(note => {
    //             const nLines = pdf.splitTextToSize(`* ${note}`, width);
    //             pdf.text(nLines, x, curY);
    //             curY += (nLines.length * 0.28);
    //         });
    //     }
    //     return curY;
    // }

    
async preProdPage(value) {
    const { pdf } = this;
    const addNewPage = () => {
            pdf.addPage();
            this.isWedding && pdf.addImage(bgImg, 'JPEG', 0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height);
            !this.isWedding && pdf.setFillColor(251, 247, 244);
            !this.isWedding && pdf.rect(0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height, 'F');
            pdf.setFontSize(42);
            pdf.addFont(montserratMedium, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
            this.isWedding && pdf.setTextColor(...(Platform.isEG ? [159, 120, 102] : [134, 126, 116]));
            !this.isWedding && pdf.setTextColor(...this.textColor);
            pdf.text(title, 1.2, 1.2);
        }
    
        const bgImg = await this.loadImage(Platform.isEG ? prePost : prePostWG);
        const title = 'PRE & POST PRODUCTION TEAM';
    
        addNewPage();
    
        let currentY = 2; 
        let itemsOnPage = 0; 
        value.forEach((e) => {
            if (value.length > 9  && itemsOnPage >= value.length/2) {
                addNewPage();
                currentY = 2; 
                itemsOnPage = 0;
            }
    
            pdf.setFontSize(20);
            pdf.addFont(montserrat, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
            this.isWedding && pdf.setTextColor(255, 255, 255);
    
            const textLine = `• ${e.count} ${e.name}`;
            pdf.text(textLine, 1.2, currentY, { align: 'left' });
    
            currentY += 0.6;
    
            itemsOnPage++;
                });
}

    async deliverablePage(value){
        const { pdf } = this;

        const title = 'DELIVERABLES';
        const padding = 1.2;
        const pageWidth = pdf.internal.pageSize.width;
        const pageHeight = pdf.internal.pageSize.height;
        // Notes wrap, so rows are no longer a fixed height. Page breaks
        // are driven by the running Y instead of an item count.
        const maxY = pageHeight - 0.5;
        const textWidth = pageWidth - padding * 2;
        const noteLineHeight = 0.28;
        const noteIndent = 0.25;

        const addNewPage = () => {
            pdf.addPage();
            pdf.setFillColor(...(this.isWedding ? [251, 247, 244] : this.bgColor));
            pdf.rect(0, 0, pageWidth, pageHeight, 'F');
            pdf.setFontSize(42);
            pdf.addFont(montserratMedium, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
            pdf.setTextColor(...this.textColor);
            pdf.text(title, padding, 1.2);
            return 2;
        }

        let currentY = addNewPage();

        // Notes sit a step below the deliverable they belong to, so they
        // get a lighter tint of the brand colour rather than full weight.
        const noteColor = this.textColor.map((c) => Math.round(c + (255 - c) * 0.22));

        const setNoteFont = () => {
            pdf.setFontSize(16);
            pdf.addFont(montserrat, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
            pdf.setTextColor(...noteColor);
        };

        const drawNotes = (notes, indent) => {
            const lines = [];
            setNoteFont();
            // Star marks where one note ends and the next begins;
            // continuation lines hang under the text, not the star.
            (notes || []).forEach((note) => {
                if (!note) return;
                pdf.splitTextToSize(`* ${note}`, textWidth - indent)
                    .forEach((l) => lines.push(l));
            });
            if (!lines.length) return;

            lines.forEach((line) => {
                if (currentY > maxY) {
                    currentY = addNewPage();
                    setNoteFont();
                }
                pdf.text(line, padding + indent, currentY);
                currentY += noteLineHeight;
            });
        };

        value.forEach((e) => {
            if (currentY > maxY) currentY = addNewPage();

            const lname = `• ${e.display_data.display_name.lname}`;
            const rname = e.display_data.display_name.rname && `:  ${e.display_data.display_name.rname}`;

            pdf.setFontSize(22);
            pdf.setTextColor(...this.textColor);
            pdf.addFont(montserratMedium, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
            const lnameWidth = pdf.getTextWidth(lname);
            pdf.text(lname, padding, currentY);

            pdf.addFont(montserrat, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
            pdf.text(rname, padding + lnameWidth, currentY);

            currentY += 0.45;
            // Ops capped a deliverable at one note, so only the first
            // one is drawn.
            const note = (e.notes || []).find(Boolean);
            if (note) drawNotes([note], noteIndent);
            currentY += 0.15;
        });
    }

   async delDurPage(value) {
    const { pdf } = this;
    const pageHeight = pdf.internal.pageSize.height; // 7.5
    const pageWidth = pdf.internal.pageSize.width;   // 15
    const bottomMargin = 0.4;
    const padding = 1.2;
    const title = 'DELIVERY DURATION';
    const bgImg = await this.loadImage(Platform.isEG ? delDiv : delDivWG);

    // Helper: Handles background, title, and text color for every page
    const renderPageTemplate = () => {
        pdf.addPage();
        if (this.isWedding) {
            pdf.addImage(bgImg, 'JPEG', 0, 0, pageWidth, pageHeight);
            // White text for wedding (on image), Company color for non-wedding
            pdf.setTextColor(255, 255, 255); 
        } else {
            pdf.setFillColor(251, 247, 244);
            pdf.rect(0, 0, pageWidth, pageHeight, 'F');
            pdf.setTextColor(...this.textColor);
        }

        pdf.setFontSize(42);
        pdf.addFont(montserratMedium, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal');
        pdf.text(title, padding, 1.2);
        return 2.0; // Initial Y for content
    };

    let currentY = renderPageTemplate();

    // 1. Process Main Table (Product Name : Duration)
    value.delivery_data.forEach((item) => {
        // Calculate space needed for this entry (Product + Optional help text)
        const entryHeight = item.help_text ? 1.0 : 0.7;

        if (currentY + entryHeight > pageHeight - bottomMargin) {
            currentY = renderPageTemplate();
        }

        const lname = `• ${item.prod_name}`;
        const rname = `${item.duration}`;

        pdf.setFontSize(22);
        pdf.addFont(montserratMedium, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal');
        
        const rnameWidth = pdf.getTextWidth(rname);

        // Draw left side (Product)
        pdf.text(lname, padding, currentY);
        // Draw right side (Duration)
        pdf.text(rname, pageWidth - padding - rnameWidth - 0.5, currentY);

        if (item.help_text) {
            currentY += 0.3;
            pdf.setFontSize(14);
            pdf.addFont(montserrat, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
            pdf.text(`(${item.help_text})`, padding + 0.2, currentY);
        }
        currentY += 0.7;
    });

    // 2. Process Fixed Summary Notes
    const textLines = [
        `* Delivery duration begins after the post-shoot payment is received${value?.shoot_complete_amt ? ` (i.e. ${value?.shoot_complete_amt})` : ''}.`,
        "* Delivery timelines may vary a bit in peak wedding season.",
        "* Download permissions will be enabled post payments after the uploads are fully cleared including incidentals."
    ];

    currentY += 0.3; // Extra gap before summary notes

    textLines.forEach((line) => {
        const wrappedLines = pdf.splitTextToSize(line, pageWidth - (padding * 2.5));
        const blockHeight = wrappedLines.length * 0.35;

        if (currentY + blockHeight > pageHeight - bottomMargin) {
            currentY = renderPageTemplate();
        }

        pdf.setFontSize(16);
        pdf.addFont(montserrat, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal');
        pdf.text(wrappedLines, padding, currentY);
        currentY += blockHeight + 0.15;
    });

    // 3. Process Duration Strings (Paragraphs/Legal clauses)
    if (value.duration_strings && value.duration_strings.length > 0) {
        currentY += 0.3;
        value.duration_strings.forEach((str) => {
            const wrappedLines = pdf.splitTextToSize(`* ${str}`, pageWidth - (padding * 2.5));
            const blockHeight = wrappedLines.length * 0.35;

            if (currentY + blockHeight > pageHeight - bottomMargin) {
                currentY = renderPageTemplate();
            }

            pdf.setFontSize(16);
            pdf.text(wrappedLines, padding, currentY);
            currentY += blockHeight + 0.2;
        });
    }
}
    async exclusivePage() {
        const { pdf } = this;
        pdf.addPage();

        pdf.setFillColor(...this.bgColor);
        pdf.rect(0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height, 'F');

        const padding = 1.2;
        const lines = [
            { text: `Exclusively Available at ${this.company}`, fontSize: 40},
            { text: `The deliverables would be made available in \n ${this.company} Website with features like`, fontSize: 32},
            { text: 'AI Facial Detection and Smart Sharing.', fontSize: 36},
            { text: 'You can share your sweet memories with relatives and family via our website anytime, anywhere.', fontSize: 28},
        ];

        const mainLineSpacing = 0.80; 
        const wrappedLineSpacing = 0.3; 

        let totalHeight = 4.5;
        const startY = (pdf.internal.pageSize.height - totalHeight)/2;

        let currentY = startY;
        pdf.setTextColor(...this.textColor);

        lines.forEach((line, index) => {
            pdf.setFontSize(line.fontSize);
            if(index%2==0){
                pdf.addFont(montserratMedium, 'montserrat', 'normal');
                pdf.setFont('montserrat', 'normal');
            }else{
                pdf.addFont(montserrat, 'montserrat', 'normal');
                pdf.setFont('montserrat', 'normal');
            }
            const pageWidth = pdf.internal.pageSize.width - 2 * padding;
            const textLines = pdf.splitTextToSize(line.text, pageWidth);

            textLines.forEach((textLine, lineIndex) => {
                const textWidth = pdf.getTextWidth(textLine);
                const textX = (pdf.internal.pageSize.width - textWidth) / 2;
                pdf.text(textLine, textX, currentY);
                currentY += (line.fontSize / 72);

                if (lineIndex < textLines.length - 1) {
                    currentY += wrappedLineSpacing;
                }
            });

            if (index < lines.length - 1) {
                currentY += mainLineSpacing;
            }
        });
    }

    async pricingPage(value) {
        const { pdf } = this;
        pdf.addPage();
    
        pdf.setFillColor(251, 247, 244);
        pdf.rect(0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height, 'F');
    
        const title = 'QUOTATION';
        pdf.setFontSize(42);
        pdf.addFont(montserratMedium, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal');
        pdf.setTextColor(...this.textColor);
        const textWidth = pdf.getTextWidth(title);
        const x = (pdf.internal.pageSize.width - textWidth) / 2;
        pdf.text(title, x, 1.2);
    
        let currentY = 2;
        let itemsOnPage = 0;
        const mainLineSpacing = 0.80;
        const wrappedLineSpacing = 0.3;
    
        value.forEach((e, index) => {
            var collapseCount = this.data.estimation_details.preview_list
                .flat()
                .filter(item => 'is_collapsed' in item)
                .length;

            if (!this.data.estimation_details.is_final ? itemsOnPage >= (this.data.estimation_details?.advance_url ? (collapseCount >= 2 ? 6 : 4) : 7) : itemsOnPage >= 7) {
                pdf.addPage();
                currentY = 2;
                itemsOnPage = 0;
            }
    
            const lname = `• ${e.display_name.lname}:`;
            const rname = `\u20B9 ${e.display_name.cost}`;
            const color = e.display_name?.web_color_code
            const textDecoration = e.display_name?.text_transform
    
            pdf.setFontSize(30);
            color ? pdf.setTextColor(color) : pdf.setTextColor(...this.textColor);
            const pageWidth = pdf.internal.pageSize.width;
            const lnameX = (pageWidth / 2 - 5)
            const rnameX = (pageWidth / 2 + 5) - pdf.getTextWidth(rname); 
            const lnameWidth = pdf.getTextWidth(lname);
            const rnameWidth = pdf.getTextWidth(rname);

            if(e.display_name?.bold){
                pdf.addFont(montserratMedium, 'montserrat', 'normal');
                pdf.setFont('montserrat', 'normal');
            }else{
                pdf.addFont(montserrat, 'montserrat', 'normal');
                pdf.setFont('montserrat', 'normal');
            }
            pdf.text(lname, lnameX, currentY);
            pdf.text(rname, rnameX, currentY);
            if(textDecoration){
                pdf.setDrawColor(187, 10, 0)
                pdf.setLineWidth(0.04)
                pdf.line(lnameX + 0.2, currentY - 0.12, lnameX + lnameWidth, currentY - 0.12)
                pdf.setDrawColor(187, 10, 0)
                pdf.setLineWidth(0.04)
                pdf.line(rnameX, currentY - 0.12, rnameX + rnameWidth, currentY - 0.12)
            }
            if(e.display_substr?.name){
                pdf.setFontSize(16);
                pdf.addFont(montserratMedium, 'montserrat', 'normal');
                pdf.setFont('montserrat', 'normal');
                currentY += 0.3;
            }
            e.display_substr?.name && pdf.text(`(${e.display_substr.name})`, lnameX+0.2, currentY)
    
            currentY += 0.6;
            itemsOnPage++;
        });

        if(this.data.estimation_details?.advance_url){
            const pageWidth = pdf.internal.pageSize.width;
            pdf.setFontSize(20);
                
            const text = 'Pay Advance\u2192';
            const textWidth = pdf.getTextWidth(text);
            const textX = (pageWidth - textWidth) / 2;
            const textY = currentY;
            const paddingX = 0.1;
            const paddingY = 0.2;
        
            pdf.textWithLink(text, textX, textY, {
                url: this.data.estimation_details.advance_url
            });
        
            const textHeight = 0.2;
        
            const buttonX = textX - paddingX;
            const buttonY = textY - textHeight + paddingY / 2 - 0.2;
            const buttonWidth = textWidth + paddingX * 2;
            const buttonHeight = textHeight + paddingY;
            const borderRadius = 0.1;
            pdf.setLineWidth(0.02);
            pdf.setDrawColor(...this.textColor)
            pdf.roundedRect(buttonX, buttonY, buttonWidth, buttonHeight, borderRadius, borderRadius);
            currentY += 0.7;
        }

        if (this.data.estimation_details.hasOwnProperty('inclusions_data') && this.data.estimation_details['inclusions_data'].length > 0) {
            pdf.setFontSize(20);
            pdf.setTextColor(...this.textColor);
            currentY += 0.1;
            value.length == 6 && pdf.addPage();
            if (value.length == 6) currentY = 1.2;

            this.data.estimation_details['inclusions_data'].forEach((e) => {
            const text = e.desc;
            const pageWidth = pdf.internal.pageSize.width;
            const maxWidth = pageWidth - 2.4;
            const wrappedLines = pdf.splitTextToSize(text, maxWidth);

            pdf.addFont(montserrat, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');

            const lineHeight = 0.4;
            const totalHeight = wrappedLines.length * lineHeight;
            const pageHeight = pdf.internal.pageSize.height;
            const bottomPadding = 0.5;

            if (currentY + totalHeight > pageHeight - bottomPadding) {
                pdf.addPage();
                currentY = 1.2;
            }

            wrappedLines.forEach((line) => {
                const lineWidth = pdf.getTextWidth(line);
                pdf.text(line, (pageWidth - lineWidth) / 2, currentY);
                currentY += lineHeight;
            });
            });
        }
        
        if (!this.data.estimation_details.is_final) {
            const textLines = [
            "* This proposal does not guarantee that teams and dates are blocked, availability would be subjected to the date of confirmation."
            ];
        
            pdf.setFontSize(20);
            pdf.addFont(montserratMedium, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
            pdf.setTextColor(...this.textColor);
            currentY += 0.2;

            const pageHeight = pdf.internal.pageSize.height;
            const bottomPadding = 0.5; // Adjust as needed for bottom margin

            textLines.forEach((line, index) => {
            pdf.setFontSize(20);
            const pageWidth = pdf.internal.pageSize.width;
            const wrappedLines = pdf.splitTextToSize(line, pageWidth / 1.5);

                const lineHeight = (20 / 72) - 0.2;
            const totalHeight = wrappedLines.length * lineHeight;

            if (currentY + totalHeight > pageHeight - bottomPadding) {
                pdf.addPage();
                currentY = 1.2;
            }

            wrappedLines.forEach((wrappedLine, lineIndex) => {
                const lineWidth = pdf.getTextWidth(wrappedLine);
                pdf.text(wrappedLine, (pageWidth - lineWidth) / 2, currentY);
                currentY += lineHeight;

                if (lineIndex < wrappedLines.length - 1) {
                currentY += wrappedLineSpacing;
                }
            });

            if (index < textLines.length - 1) {
                currentY += mainLineSpacing;
            }
            });
        }
    }

    async addOnPage(value) {
        const { pdf } = this;
    
        const addNewPage = () => {
            pdf.addPage();
            pdf.setFillColor(...this.bgColor);
            pdf.rect(0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height, 'F');
            pdf.setFontSize(42);
            pdf.addFont(montserratMedium, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
            pdf.setTextColor(...this.textColor);
            pdf.text(title, 1.2, 1.2);
        }
    
        const title = 'Add-ons';
    
        addNewPage();
    
        let currentY = 2;
        let itemsOnPage = 0;
        const padding = 1.2;
    
        value.forEach((e) => {
            if (value.length > 9  && itemsOnPage >= value.length/2) {
                addNewPage();
                currentY = 2;
                itemsOnPage = 0;
            }
    
            const lname = `• ${e.name}:`;
            const rname = `  \u20B9 ${e.cost}`;
    
            pdf.setFontSize(22);
            pdf.setTextColor(...this.textColor);
            pdf.addFont(montserrat, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
            const rnameWidth = pdf.getTextWidth(rname);
            const pageWidth = pdf.internal.pageSize.width;
    
            pdf.text(lname, padding, currentY);
    
            pdf.text(rname, pageWidth - padding - rnameWidth, currentY);
    
            currentY += 0.6;
            itemsOnPage++;
        });
    }

    async installmentPage(value) {
    const { pdf } = this;
    const pageHeight = pdf.internal.pageSize.height; // 7.5
    const pageWidth = pdf.internal.pageSize.width;   // 15
    const bottomMargin = 0.8;
    const paddingX = 1.2;
    const title = 'PAYMENT POLICY';

    // Helper: Sets up background, Title, and returns starting Y
    const renderPageTemplate = () => {
        pdf.addPage();
        pdf.setFillColor(251, 247, 244);
        pdf.rect(0, 0, pageWidth, pageHeight, 'F');
        
        pdf.setFontSize(42);
        pdf.setTextColor(...this.textColor);
        pdf.addFont(montserratMedium, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal');
        pdf.text(title, 1.2, 1.2);
        
        return 2.0; // Start content at Y = 2.0
    };

    let currentY = renderPageTemplate();

    for (const installment of value) {
        // --- 1. PRE-CALCULATE HEIGHT ---
        // Base line is ~0.4. Due date adds ~0.25. Pay button adds ~0.4.
        let blockHeight = 0.5; 
        if (installment.display_name.due_date) blockHeight += 0.3;
        if (installment.display_name.coins_applied > 0) blockHeight += 0.3;
        if (installment.display_name.pay_link) blockHeight += 0.5;
        
        // Check vertical overflow
        if (currentY + blockHeight > pageHeight - bottomMargin) {
            currentY = renderPageTemplate();
        }

        // --- 2. RENDER INSTALLMENT TITLE & AMOUNT ---
        const installmentTitle = `• ${installment.display_name.lname} ${installment.display_name.percent} ${installment.display_name.desc} :`;
        const installmentAmount = `\u20B9 ${installment.display_name.cost}`;
        
        pdf.setFontSize(26);
        pdf.setTextColor(...this.textColor);
        pdf.addFont(montserrat, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal');
        
        const installmentTitleWidth = pdf.getTextWidth(installmentTitle);
        const amountWidth = pdf.getTextWidth(installmentAmount);
        
        // Draw Title
        pdf.text(installmentTitle, paddingX, currentY);

        // Draw "Paid" status if applicable
        if (installment.display_name.is_paid) {
            pdf.setFontSize(18);
            pdf.setFont("helvetica", "italic"); 
            pdf.text('Paid', paddingX + installmentTitleWidth + 0.1, currentY);
            // Revert font
            pdf.setFont('montserrat', 'normal');
            pdf.setFontSize(26);
        }

        // Draw Amount (Right Aligned)
        pdf.text(installmentAmount, pageWidth - paddingX - amountWidth, currentY);

        // --- 3. RENDER DUE DATE ---
        if (installment.display_name.due_date) {
            currentY += 0.3;
            pdf.setFontSize(14);
            pdf.addFont(montserratMedium, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
            pdf.text(`${installment.display_name.due_date}`, paddingX + 0.25, currentY);
            currentY += 0.1; // Small gap after date
        }

        // --- 3b. RENDER EG COINS (same line the page shows under the name) ---
        if (installment.display_name.coins_applied > 0) {
            currentY += 0.3;
            pdf.setFontSize(14);
            pdf.addFont(montserratMedium, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
            const coinsName = Platform.isEG ? 'EG Coins' : 'WG Coins';
            pdf.text(
                `${installment.display_name.coins_applied} ${coinsName} applied (${installment.display_name.coin_rname})`,
                paddingX + 0.25, currentY);
            currentY += 0.1;
        }

        // --- 4. RENDER PAY BUTTON ---
        if (installment.display_name.pay_link) {
            currentY += 0.35;
            pdf.setFontSize(15);
            const btnText = 'Pay\u2192';
            const btnTextWidth = pdf.getTextWidth(btnText);
            
            // Position button after the title but before the amount
            const btnX = paddingX + 0.25; 
            const btnY = currentY;

            // Text with Link
            pdf.textWithLink(btnText, btnX, btnY, { url: installment.display_name.pay_link });

            // Drawing the rounded border for the button
            const padH = 0.1;
            const padV = 0.2;
            pdf.setLineWidth(0.02);
            pdf.setDrawColor(...this.textColor);
            pdf.roundedRect(
                btnX - padH, 
                btnY - 0.2, 
                btnTextWidth + (padH * 2), 
                0.28, 
                0.05, 0.05
            );
        }

        // Space before the next installment block
        currentY += 0.6;
        }
        const warningText = "* Please note that the token amount is non-refundable and will be forfeited in the event of cancellation.";
        const warningText2 = "* All credit card payments will attract additional payment gateway charges (internet handling fees) (except advance payments)";
        const warningLineHeight = 0.35;
        
        const applyWarningStyle = () => {
            pdf.setFontSize(16);
            pdf.setTextColor(...this.textColor);
            pdf.addFont(montserratMedium, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
        };
        
        applyWarningStyle();

        const warnings = hasTokenInstallment(value)
            ? [warningText, warningText2]
            : [warningText2];

        warnings.forEach((warning) => {
            const wrappedWarning = pdf.splitTextToSize(warning, pageWidth - (paddingX * 2));
            const warningHeight = wrappedWarning.length * warningLineHeight;
        
            if (currentY + warningHeight > pageHeight - bottomMargin) {
                currentY = renderPageTemplate();
                // renderPageTemplate resets title font styles, so restore warning style.
                applyWarningStyle();
            }
        
            pdf.text(wrappedWarning, paddingX, currentY);
            currentY += warningHeight + 0.2;
        });
}

    async CancellationPolicyPage(value) {
        const { pdf } = this;
        pdf.addPage();
    
        pdf.setFillColor(251, 247, 244);
        pdf.rect(0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height, 'F');
    
        const title = 'Cancellation Policy';
        pdf.setFontSize(42);
        pdf.setTextColor(...this.textColor);
        pdf.addFont(montserratMedium, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal');
        const paddingX = 1.2;
        pdf.text(title, paddingX, 1.2);
    
        pdf.setFontSize(20);
        pdf.setTextColor(...this.textColor);
        pdf.addFont(montserrat, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal');
        pdf.text('In case of any cancellation by the client, the following applies:', paddingX, 1.8);
    
        const header = ['Cancellation Time', 'Cancellation Fee'];
        const pageWidth = pdf.internal.pageSize.width;
        const contentWidth = pageWidth - 2 * paddingX;
        const colWidths = [contentWidth / 2, contentWidth / 2];
        let startY = 2.5;
        const rowHeight = 0.8;
    
        pdf.addFont(montserratMedium, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal');
        pdf.setFontSize(24);
        let colX = paddingX;
    
        pdf.setFillColor(251, 247, 244);
        pdf.rect(paddingX, startY - 0.5, contentWidth, rowHeight, 'F');
    
        for (let i = 0; i < header.length; i++) {
            const headerText = header[i];
            const textWidth = pdf.getTextWidth(headerText);
            const centerX = colX + (colWidths[i] - textWidth) / 2;
            pdf.text(headerText, centerX, startY);
            colX += colWidths[i];
        }
    
        pdf.setDrawColor(169, 160, 152); 
        pdf.setLineWidth(0.01);
        pdf.rect(paddingX, startY - 0.5, contentWidth, rowHeight);
    
        const separationX = paddingX + colWidths[0];
        pdf.setDrawColor(169, 160, 152); 
        pdf.setLineWidth(0.01);
        pdf.line(separationX, startY - 0.5, separationX, startY + value.length * rowHeight + 0.3);
    
        pdf.addFont(montserratMedium, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal');
        pdf.setFontSize(20);
        startY += rowHeight;
    
        value.forEach(rowData => {
            colX = paddingX;
    
            const row = [rowData.time_str, rowData.display_fee];
    
            row.forEach((cellText, index) => {
                const textWidth = pdf.getTextWidth(cellText);
                const centerX = colX + (colWidths[index] - textWidth) / 2;
                pdf.text(cellText, centerX, startY);
                colX += colWidths[index];
            });
    
            pdf.setDrawColor(169, 160, 152); 
            pdf.setLineWidth(0.01);
            pdf.rect(paddingX, startY - 0.5, contentWidth, rowHeight);
    
            startY += rowHeight;
        });
    }

    async whyPage() {
        const { pdf } = this;
        pdf.addPage();
    
        const bgImg = await this.loadImage(Platform.isEG ? whyEG : whyWG);
        pdf.addImage(bgImg, 'JPEG', 0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height);
    
        pdf.setFontSize(42);
        pdf.setTextColor(...(Platform.isEG ? [159, 120, 102] : [134, 126, 116])); 
    
        const title = Platform.isEG ? 'WHY EVENTGRAPHIA?' : 'WHY WEDGRAPHIA?';
        pdf.addFont(montserratMedium, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal');
        pdf.text(title, 1.2, 1.2);

        pdf.setFontSize(20);
        pdf.addFont(montserrat, 'montserrat', 'normal');
        pdf.setFont('montserrat', 'normal');
        pdf.setTextColor(255, 255, 255);
        const textLines = [
            `${this.company} is a Premium Event Photography Service space. We provide seamless`,
            "end-to-end solutions right from booking inquiry to the delivery of photos, videos and",
            "albums, all digitally using our web app.",
            "",
            "• India's Largest Event Photography Company",
            "• Serving 175+ Cities",
            "• 210+ Professionals",
            "• Covered 500+ Weddings",
            "• State of the art Equipments",
            "• Customers - BMW, TAJ, Uber, Dominos, Harley Davidson, Hello English, Oyo Rooms",
            "  and many more."
        ];

        let currentY = 2;
        textLines.forEach(line => {
            pdf.text(line, 1.2, currentY, { align: 'left' });
            currentY += 0.5;
        })
    }
    
async TermsPage() {
        const { pdf } = this;
        const setupPageTemplate = () => {
            pdf.setFillColor(251, 247, 244);
            pdf.rect(0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height, 'F');
    
            const title = 'Terms & Conditions';
            pdf.setFontSize(42);
            pdf.setTextColor(...this.textColor);
            pdf.addFont(montserratMedium, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
            const titleX = 1.2;
            pdf.text(title, titleX, 1);
        };
    
        pdf.addPage();
        setupPageTemplate();
    
        const terms = termsConditions(true)
    
        let currentY = 1.6;
        const pageHeight = pdf.internal.pageSize.height;
        const bottomMargin = 1.2;
        const maxY = pageHeight - bottomMargin;

        const checkPageBreak = (requiredSpace = 0.35) => {
            if (currentY + requiredSpace > maxY) {
                pdf.addPage();
                setupPageTemplate();
                currentY = 1.25;
            }
        };
        
        const pageWidth = pdf.internal.pageSize.width;
        const contentWidth = pageWidth - 2.4;
    
        terms.forEach(term => {
            pdf.setFontSize(20);
            pdf.setTextColor(...this.textColor);
            pdf.addFont(montserratMedium, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
            const headingWidth = pdf.getTextWidth(term.heading);
            const startX = 1.2;
    
            const firstLineTextWidth = contentWidth - headingWidth - 0.4;
            
            const firstLineWrappedText = pdf.splitTextToSize(term.text, firstLineTextWidth);
    
            pdf.text(`• ${term.heading}`, startX, currentY);
            pdf.addFont(montserrat, 'montserrat', 'normal');
            pdf.setFont('montserrat', 'normal');
            pdf.text(firstLineWrappedText[0], startX + headingWidth + 0.1, currentY);
            
            const remainingText = term.text.replace(firstLineWrappedText[0], "").trim();
            
            if (remainingText) {
                const remainingWrappedText = pdf.splitTextToSize(remainingText, contentWidth);
              for (let i = 0; i < remainingWrappedText.length; i++) {
                        checkPageBreak(0.35);

            pdf.setFontSize(20);
            pdf.addFont(montserrat, 'montserrat', 'normal');
                        pdf.setFont('montserrat', 'normal');

                    currentY += 0.35;
            pdf.text(remainingWrappedText[i], startX, currentY);
                }
            }
            checkPageBreak(0.7);
            currentY += 0.7;
        });

        const today = new Date();
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = today.toLocaleDateString('en-US', options);
        const generatedText = `Generated on: ${formattedDate}`
        const generatedTextWidth = pdf.getTextWidth(generatedText);
        const xPosition = (pageWidth - generatedTextWidth + 1.4)/2;
        currentY = 7;
        pdf.setFontSize(14);
        pdf.text(generatedText, xPosition, currentY);
    }
    

async generateAndSavePDF() {
    const quoteData = this.data.estimation_details;

    // Dynamically calculate total tasks based on conditional steps
    let totalTasks = 2; // coverPage + TermsPage

    if (Platform.isEG && this.isWedding) totalTasks++; // awardPage
    if (!this.isWedding) totalTasks++; // nonWeddingWhy
    if (quoteData.estimation_data?.length > 0) totalTasks += 2; // schedulePage + eventsPage
    if (quoteData.production_team?.length > 0) totalTasks++; // preProdPage
    if (quoteData.booking_products?.length > 0) totalTasks++; // deliverablePage
    if (quoteData.delivery_duration?.delivery_data?.length > 0) totalTasks++; // delDurPage
    totalTasks++; // exclusivePage
    if (quoteData.preview_list?.length > 0) totalTasks++; // pricingPage
    if (quoteData.additional_products?.length > 0) totalTasks++; // addOnPage
    if (quoteData.installment_data?.length > 0) totalTasks++; // installmentPage
    if (quoteData.cancellation_policy?.length > 0) totalTasks++; // CancellationPolicyPage
    if (this.isWedding) totalTasks++; // whyPage
    totalTasks++; // save PDF step

    let completedTasks = 0;

    const updateProgress = async () => {
        completedTasks++;
        const progress = Math.round((completedTasks / totalTasks) * 100);

        this.progressCallback(progress);

        await waitForNextPaint(); // ← this gives React time to re-render

        if(progress == 100){
            this.loadingCallback(false);
        }
    };

    await this.coverPage();
    await updateProgress();

    if (Platform.isEG && this.isWedding) {
        await this.awardPage();
        await updateProgress();
    }

    if (!this.isWedding) {
        await this.nonWeddingWhy();
        await updateProgress();
    }

    if (quoteData.estimation_data?.length > 0) {
        await this.schedulePage(quoteData.estimation_data);
        await updateProgress();

        await this.eventsPage(quoteData.estimation_data);
        await updateProgress();
    }

    if (quoteData.production_team?.length > 0) {
        await this.preProdPage(quoteData.production_team);
        await updateProgress();
    }

    if (quoteData.booking_products?.length > 0) {
        await this.deliverablePage(quoteData.booking_products);
        await updateProgress();
    }

    if (quoteData.delivery_duration?.delivery_data?.length > 0) {
        await this.delDurPage(quoteData.delivery_duration);
        await updateProgress();
    }

    await this.exclusivePage();
    await updateProgress();

    if (quoteData.preview_list?.length > 0) {
        await this.pricingPage(quoteData.preview_list);
        await updateProgress();
    }

    if (quoteData.additional_products?.length > 0) {
        await this.addOnPage(quoteData.additional_products);
        await updateProgress();
    }

    if (quoteData.installment_data?.length > 0) {
        await this.installmentPage(quoteData.installment_data);
        await updateProgress();
    }

    if (quoteData.cancellation_policy?.length > 0) {
        await this.CancellationPolicyPage(quoteData.cancellation_policy);
        await updateProgress();
    }

    if (this.isWedding) {
        await this.whyPage();
        await updateProgress();
    }

    await this.TermsPage();
    await updateProgress();
    window.__LAST_DOWNLOAD_NAME__ = `${this.data.estimation_details.quot_title}.pdf`;
    this.pdf.save(window.__LAST_DOWNLOAD_NAME__);
    await updateProgress();
}
    
}

export function GeneratePdf(data, isWedding, progressCallback, loadingCallback) {
    const pdfGen = new PDFGenerator(data, isWedding, progressCallback, loadingCallback);
    pdfGen.generateAndSavePDF();
}


// this  is a micro delay that gives the browser time to visually reflect progress updates before continuing to the next heavy task.    (gives time for state to update)
const waitForNextPaint = () =>
  new Promise(resolve => requestAnimationFrame(() => resolve()));